import React from 'react';
import './Blog.css';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import BlogItem from './BlogItem';
import Reveal from 'react-reveal/Reveal';


const Blog = ({ posts }) => {
  const postItems = posts.map((post, index) => (
    <BlogItem key={index} image={post.image} title={post.title} excerpt={post.excerpt} date={post.date} slug={post.slug} />
  ));

  return (
    <div className="blog-wrapper">
      <Reveal effect="grow-in-bottom">
        <section className="blog" id="blog">
          <h1 className="section__name text-center w-100">Blog</h1>
          <div className="blog-items">
            {postItems}
          </div>
          <Link to="/blog" className="my-btn more-posts-btn">További bejegyzések</Link>
        </section>
      </Reveal>
    </div>
  );
};


Blog.propTypes = {
  posts: PropTypes.array.isRequired
};

export default Blog;



// WEBPACK FOOTER //
// ./src/components/Home/Blog/Blog.js